module.exports = __webpack_public_path__ + "img/clientCountries.2835ba5b.svg";